import React from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';

import {setShowAllProblematic} from 'store/entities/submissions';

import {mdiInformationOutline} from '@mdi/js';
import Icon from '@mdi/react';

import {Column} from 'components/UIComponents/Layout/Column';
import Tooltip from 'components/UIComponents/Tooltip';
import {Checkbox} from "../../../components/UIComponents/Form";

const AllProblematicFilter = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const {showAllProblematic} = useSelector(state => state.submissions);

    return (
        <Column
            mobile={{size: 12}}
            tablet={{size: 6}}
            desktop={{size: 12}}
            widescreen={{size: 6}}
            fullhd={{size: 5}}
        >
            <Checkbox
                className="toggle-problematic"
                onChange={evt => dispatch(setShowAllProblematic(evt.target.checked))}
                checked={showAllProblematic}
                id="toggleProblematic"
            >
                {t('datagate.external.submissions.filter.showAllProblematic')}
                <Tooltip style=""
                         html={
                    <span>
                    {t('datagate.external.submissions.filter.showAllProblematic.tooltip')}
                    </span>
                }>
                    <Icon path={mdiInformationOutline} size={0.75}/>
                </Tooltip>
            </Checkbox>
        </Column>
    );
};

export default AllProblematicFilter;
